import { TableColumn } from '../../models';
import { MultiTagCellComponent, MultiTagCellProps } from './multi-tag.component';

export class MultiTagColumn<I> extends TableColumn<I, MultiTagCellProps> {
  readonly component = MultiTagCellComponent;
}
